import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { isEmpty, isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { organizationUsersById } from "reduxSlices/organizationUsersSlice"
import { ProfileIcon } from "shared/icons"

const MAX_SHOWING = 3

const TaskHeaderAssigneesOverview = ({ assigneeIds }) => {
  const assignees = useSelector(organizationUsersById(assigneeIds), isEqual)

  if (isEmpty(assignees)) return null

  const numberOfTruncated = assignees.length - MAX_SHOWING

  return (
    <div className="hidden lg:flex lg:gap-1">
      {
        assignees.map((user, index) => (
          index < MAX_SHOWING ? (
            <ProfileIcon
              key={user.id}
              user={user}
              includeScreenReaderText
            />
          ) : null
        ))
      }
      {
        numberOfTruncated > 0 && (
          <div
            className={clsx(
              "h-8 w-8 flex items-center justify-center bg-lightgray-3 rounded-full",
              "font-semibold text-xs text-dark",
            )}
          >
            <span className="-ml-0.5">{`+${numberOfTruncated}`}</span>
          </div>
        )
      }
    </div>
  )
}

TaskHeaderAssigneesOverview.propTypes = {
  assigneeIds: types.arrayOf(types.number).isRequired,
}

export default TaskHeaderAssigneesOverview
